import React from 'react';

export const HouseSearch = (props) => {
  // console.log('Add', props);
  return (
    <svg height={props.size} width={props.size} version="1.1" x="0px" y="0px" viewBox="0 0 104.5 100" enableBackground="new 0 0 104.5 100" xmlSpace="preserve">
      <g>
        <polygon points="32.235,24.046 32.235,15.958 22.132,15.958 22.132,34.148 3,53.279 10.143,60.423 19.724,50.842    19.724,90.046 83.229,90.046 83.229,50.842 92.809,60.423 99.953,53.279 51.479,4.802  " />
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./client/src/img/houseSearch.js